import { useCallback, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { WorkRule } from 'repository/timekeeper/@types/WorkRuleModel';

export const useWorkRulesTableState = () => {
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<WorkRule[]>([]);
    const [selected, setSelected] = useState<GridRowSelectionModel>([]);

    const cleanSelected = useCallback(() => {
        setSelectedRow([]);
        setSelected([]);
    }, []);

    return {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
